import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IIdeal } from "../idealModel";

export const getAllIdeals = createAsyncThunk("Ideal/FindAllIdeal", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/Ideal/FindAllIdeal`,
      {
        Title: "",
      },
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching Ideal:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createIdeal = createAsyncThunk(
  "Ideal/InsertIdeal",
  async (IdealData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ideal/InsertIdeal`,
        IdealData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Ideal:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateIdeal = createAsyncThunk(
  "Ideal/UpdateIdeal",
  async (IdealData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ideal/UpdateIdeal`,
        IdealData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Ideal :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteIdeal = createAsyncThunk(
  "Ideal/DeleteIdeal",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ideal/DeleteIdeal`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Ideal :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getIdealByID = createAsyncThunk(
  "Ideal/FindByIDIdeal",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ideal/FindByIDIdeal`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result?.Title,
        Description: result?.Description || "",
        Images: result?.Images,
        IsActive: result.IsActive ? 1 : 2,
      } as IIdeal;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Ideal:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActiveIdeals = createAsyncThunk(
  "Ideal/FindAllActiveIdeal",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Ideal/FindAllActiveIdeal`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Ideal:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactiveIdeal = createAsyncThunk(
  "Ideal/ActiveInActiveIdeal",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ideal/ActiveInActiveIdeal`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Ideal :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD

export const IdealImageUpload = createAsyncThunk(
  "Ideal/IdealImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Ideal/IdealImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Ideal Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
